var map = {
	"./CH_Logo.png": "xNRy",
	"./axios.png": "bK0S",
	"./c1x-logo.png": "E2hN",
	"./cathy_logo_new.png": "YVbD",
	"./cathy_portfolio_pic.png": "tY55",
	"./ch-icon.png": "JPaP",
	"./chai.png": "Odkg",
	"./cn.png": "KCAa",
	"./contact-bg.png": "Qg1i",
	"./css.png": "1yHG",
	"./en.png": "nLGm",
	"./gatsby-astronaut.png": "qRbu",
	"./github-icon.png": "Wht1",
	"./heart.png": "ywLV",
	"./html.png": "+IZT",
	"./inventec-logo.png": "g0qc",
	"./javascript.png": "IPBA",
	"./jquery.png": "APp+",
	"./lego.png": "+z+A",
	"./linkedin-icon.png": "yVZk",
	"./mocha.png": "Xc5y",
	"./next-page-button.png": "TTKK",
	"./nodejs.png": "tizw",
	"./npm.png": "P498",
	"./prebid.png": "Vfv1",
	"./prebidjs.png": "ZM2n",
	"./react-router.png": "+Zoy",
	"./react.png": "fVyd",
	"./tac.png": "vWXC",
	"./tw.png": "Nvcg",
	"./vpon-logo.png": "IGbC",
	"./webpack.png": "D5+a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1IgP";